import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import ReactDOM from "react-dom";
import "./App.css";
import App from "./App";
  
  const rootElement = document.getElementById("root");
  ReactDOM.render(<Router><App /></Router>, rootElement);
  
